import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { shareContent } from '../../utils/shareUtils';
import './ShareEventPage.css';

const ShareEventPage = () => {
  const navigate = useNavigate();
  const [shareMessage, setShareMessage] = useState('');

  // 구글폼 URL
  const GOOGLE_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSfXkdke0bv6UE1mZLetUOsCkc9Gs2ORUmcGZ_2T51efT8ATxQ/viewform';

  const goBack = () => {
    navigate('/events');
  };

  // 이벤트 공유 함수 (Web Share API 사용)
  const handleShareEvent = async () => {
    const shareData = {
      title: '왓퀴즈 - 교사용 무료 AI 플랫폼',
      text: '왓퀴즈 SNS 소문내기 이벤트! 공유하고 PRO 1개월권 받아가세요!',
      url: `${window.location.origin}/events/share`
    };

    // Google Analytics 이벤트 추적
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'share_event_click', {
        event_category: 'Events',
        event_label: 'share_page_share',
        value: 1
      });
    }

    const result = await shareContent(shareData);
    
    if (result.success) {
      setShareMessage('이벤트가 공유되었습니다!');
    } else if (result.error) {
      setShareMessage(result.error.includes('복사') ? 'URL이 복사되었습니다!' : '공유에 실패했습니다.');
    }

    // 메시지 자동 제거
    setTimeout(() => setShareMessage(''), 3000);
  };

  // 구글폼 열기
  const handleOpenGoogleForm = () => {
    // Google Analytics 이벤트 추적
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'share_form_submit', {
        event_category: 'Events',
        event_label: 'share_google_form',
        value: 1
      });
    }

    window.open(GOOGLE_FORM_URL, '_blank', 'noopener,noreferrer');
  };

  const prizes = [
    {
      label: '전원',
      name: '왓퀴즈 PRO 1개월권',
      detail: '참여자 전원 지급',
      isPrimary: true
    },
    {
      label: '추첨',
      name: '네이버페이 10,000원',
      detail: '매주 5명 추첨',
      isPrimary: false
    },
    {
      label: '보너스',
      name: '네이버페이 20,000원',
      detail: '블로그/인디스쿨 글 작성 시',
      isPrimary: false
    }
  ];

  return (
    <div className="share-event-page">
      <Helmet>
        <title>SNS 소문내기 이벤트 - 왓퀴즈</title>
        <meta name="description" content="왓퀴즈를 공유하고 PRO 1개월권을 받으세요! 매주 네이버페이 경품 추첨" />
        <meta property="og:title" content="SNS 소문내기 이벤트 - 왓퀴즈" />
        <meta property="og:description" content="왓퀴즈를 공유하고 PRO 1개월권을 받으세요!" />
      </Helmet>

      {/* 메인 컨텐츠 - 컴팩트 */}
      <section className="main-content">
        <div className="container">
          <button className="back-btn-compact" onClick={goBack}>
            ← 이벤트 목록
          </button>
          
          <div className="event-header-compact">
            <div className="bonus-badge">Bonus Event</div>
            <h1 className="event-title-compact">SNS 소문내기 이벤트</h1>
            <p className="event-highlight">단체 모집글도 대환영!</p>
            <p className="event-description">
              카카오톡, 블로그, 인스타그램, 인디스쿨 등 SNS에 공유만 해도 추첨경품을 드립니다.
            </p>
          </div>

          {/* 경품 */}
          <div className="prizes-compact">
            {prizes.map((prize, index) => (
              <div 
                key={index} 
                className={`prize-card-compact ${prize.isPrimary ? 'primary' : ''}`}
              >
                <span className="prize-label-compact">{prize.label}</span>
                <h3 className="prize-name-compact">{prize.name}</h3>
                <p className="prize-detail-compact">{prize.detail}</p>
              </div>
            ))}
          </div>

          {/* 버튼 */}
          <div className="action-buttons-compact">
            <button className="btn-action primary-action" onClick={handleOpenGoogleForm}>
              소문내기 제출
            </button>
            <button className="btn-action secondary-action" onClick={handleShareEvent}>
              이벤트 공유하기
            </button>
          </div>

          {shareMessage && (
            <div className="share-message-compact">
              {shareMessage}
            </div>
          )}

          <p className="event-note">*매 주 수요일, 발표 및 상품 발송</p>
        </div>
      </section>

      {/* 참여 방법 */}
      <section className="how-to-section">
        <div className="container">
          <h2 className="section-title">참여 방법</h2>
          <div className="steps">
            <div className="step">
              <div className="step-num">1</div>
              <div className="step-content">
                <h3>이벤트 공유하기</h3>
                <p>카카오톡, SNS 등에 왓퀴즈를 공유해주세요</p>
              </div>
            </div>
            <div className="step">
              <div className="step-num">2</div>
              <div className="step-content">
                <h3>구글폼 제출</h3>
                <p>공유 내용을 구글폼에 제출해주세요</p>
              </div>
            </div>
            <div className="step">
              <div className="step-num">3</div>
              <div className="step-content">
                <h3>경품 수령</h3>
                <p>추첨 후 개별 연락드립니다</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ShareEventPage;

